import { execute } from '@/api/execute'
import { GET } from '@/api/types'
import { addQueryParams } from '@/util/index.js'

const ENDPOINT = 'history/animaltypes'

export default {
  list (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/`, params))
  }
}
